import { useState, useEffect, useCallback } from "react"
import { snakeToCamelKeys } from "utils/helpers"
import PropTypes from "prop-types"
import SelectionTypeForm from "./SelectionTypeForm"
import pcoUrl from "@planningcenter/url"
import { api } from "utils/api"

const SelectionTypeNew = props => {
  const [isLoading, setIsLoading] = useState(true)
  const [defaults, setDefaults] = useState({})

  const fetchData = useCallback(async () => {
    setIsLoading(true)

    const resp = await api.get(`${pcoUrl(railsEnv)("api")}/registrations/v2/selection_type_options`)

    setDefaults(snakeToCamelKeys(resp.data.attributes))
    setIsLoading(false)
  }, [])

  const newSelectionType = {
    ...defaults,
    name: "",
    confirmationEmailMessage: "",
    publiclyAvailable: true,
    allowDeposit: false,
    minimumDeposit: null,
    priceCents: null,
    currencySymbol: props.signup.currencySymbol,
    canBeDeleted: false
  }

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return isLoading ? null : <SelectionTypeForm {...props} selectionType={newSelectionType} />
}

SelectionTypeNew.propTypes = {
  signup: PropTypes.shape({
    currencySymbol: PropTypes.string
  })
}

export default SelectionTypeNew
